import {useMutation} from "@tanstack/react-query";
import {setGroupClaims} from "../services/ClaimService";

export function useSetGroupClaims() {
    return useMutation({
        mutationFn: setGroupClaims,
    });
}
